export default function Header() {
  return (
    <header>
      <div className="bg-black mx-auto p-4 text-white border-b-4 border-pink-300">
        <h1 className="text-center font-semibold text-xl">
          React Elections
        </h1>
      </div>
    </header>
  )
}
